/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zombie_Nav_CreateInputs */

const en_zombie_nav_create = /** @type {(inputs: Zombie_Nav_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

const zh_zombie_nav_create = /** @type {(inputs: Zombie_Nav_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成器`)
};

/**
* | output |
* | --- |
* | "Studio" |
*
* @param {Zombie_Nav_CreateInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const zombie_nav_create = /** @type {((inputs?: Zombie_Nav_CreateInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zombie_Nav_CreateInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_zombie_nav_create(inputs)
	return zh_zombie_nav_create(inputs)
});
export { zombie_nav_create as "zombie.nav.create" }